export default function Testimonial() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
            <div>
              <span className="inline-flex items-center gap-2 text-sm font-semibold text-primary-700 mb-4">
                <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                Verified Buyer
              </span>
              <blockquote className="font-heading text-2xl md:text-4xl font-medium italic text-foreground-900 leading-snug">
                &ldquo;The Vigorbuy Spreadsheet saved me countless hours of searching. I found trusted sellers and verified products organized exactly how I needed. It is the most complete directory I have ever used.&rdquo;
              </blockquote>
              <div className="mt-6 flex items-center gap-3">
                <div>
                  <p className="font-semibold text-foreground-900 text-sm">Michael R.</p>
                  <div className="flex items-center gap-1 mt-0.5">
                    <span className="text-xs text-foreground-500">Verified Purchase</span>
                    <span className="inline-flex items-center gap-0.5 text-accent-500">
                      <i className="ri-star-fill text-xs"></i>
                      <i className="ri-star-fill text-xs"></i>
                      <i className="ri-star-fill text-xs"></i>
                      <i className="ri-star-fill text-xs"></i>
                      <i className="ri-star-fill text-xs"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20abstract%20portrait%20silhouette%20in%20soft%20cream%20and%20sage%20green%20tones%2C%20artistic%20illustration%20style%2C%20Scandinavian%20design%20aesthetic%2C%20warm%20neutral%20gradient%20background%2C%20airy%20atmosphere%2C%20clean%20modern%20composition&width=800&height=1000&seq=testimonial-portrait-v2&orientation=portrait"
                alt="Verified buyer testimonial"
                className="w-full h-auto object-cover rounded-lg"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}